import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const page = {
  "slug": "recycling-centers",
  "title": "Recycling Centers",
  "summary": "Horizontal, full-eject, and specialty balers for multiple grades and changing recyclable materials.",
  "image": "equipment/horizontal-balers/horizontal-5.jpg",
  "highlights": [
    "Material-specific recommendations",
    "Baler loading and discharge planning",
    "Serviceable equipment design"
  ],
  "section": "Industries"
};

const navItems = [
  {
    "slug": "paper-mills",
    "title": "Paper Mills"
  },
  {
    "slug": "corrugated-container-manufacturers",
    "title": "Corrugated Container Manufacturers"
  },
  {
    "slug": "nonwoven-mills",
    "title": "Nonwoven Mills"
  },
  {
    "slug": "textile-mills-cotton-gins",
    "title": "Textile Mills & Cotton Gins"
  },
  {
    "slug": "distribution-centers",
    "title": "Distribution Centers"
  },
  {
    "slug": "manufacturers-industrial-plants",
    "title": "Manufacturers & Industrial Plants"
  },
  {
    "slug": "warehouses",
    "title": "Warehouses"
  },
  {
    "slug": "recycling-centers",
    "title": "Recycling Centers"
  }
];

const images = pageImages['recycling-centers'];


function RecyclingCenters() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          {navItems.map((item) => (
            <Link key={item.slug} className={item.slug === page.slug ? 'active' : ''} to={`/${item.slug}`}>{item.title}</Link>
          ))}
        </aside>
        <article className="article">
          <span className="eyebrow">{page.section}</span>
          <h2>{page.title}</h2>
          <div className="body-copy page-summary-copy">{page.summary}</div>
          {page.highlights?.length ? (
            <div className="page-summary-notes">
              {page.highlights.map((item) => <span key={item}>{item}</span>)}
            </div>
          ) : null}
          <PagePhotoViewer title={page.title} images={images} leadText={"Recycling centers often process changing materials and multiple grades, which is why C+M full-eject balers are emphasized for 100 percent bale separation."} eyebrow="Application Photos" />
          <div className="content-stack">
            <section className="content-block">
              <h3>Recycling Center Grade Separation</h3>
              <div className="body-copy">Recycling centers often process changing materials and multiple grades, which is why C+M <strong>full-eject balers</strong> are emphasized for 100 percent bale separation.</div>
              <div className="body-copy">Open-end manual, automatic tie, conveyors, and full-eject machines can be combined depending on grade count, material memory, throughput, and bale handling needs.</div>
              <div className="detail-points">
                <div className="detail-point">Multiple recyclable grades</div>
                <div className="detail-point">Full-eject separation between materials</div>
                <div className="detail-point">Conveyor and bale handling integration</div>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default RecyclingCenters;
